class CollapsibleCards extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.controls = this.querySelectorAll(
      '[data-controls-prev], [data-controls-next]'
    );
    this.controls.forEach((control) =>
      control.addEventListener('click', this.handleOnControlClick.bind(this))
    );
  }

  init() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        750: {
          spaceBetween: 24,
        },
      },
    });
  }

  handleOnControlClick(event) {
    if (!this.slider) return;

    this.slider[
      event.target.hasAttribute('data-controls-prev')
        ? 'slidePrev'
        : 'slideNext'
    ]();
  }
}

customElements.define('collapsible-cards', CollapsibleCards);
